import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-software-status-icon',
  templateUrl: './software-status-icon.component.html',
  imports: [MatIcon, MatTooltip],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SoftwareStatusIconComponent {
  softwareWarning = input<boolean | null | undefined>();
}
